import axios from "axios";
import {
  FETCH_USER,
  LOGOUT,
  CHECK_TOKEN,
  UPDATE_DATA,
  FORGET_PASSWORD,
  USER_DETAIL_OTP_FORGOTPASS
} from "./types";
import setAuthorizationToken from "../utils/setAuthorizationToken";
//import jwt_decode from "jwt-decode";
import notification from "../utils/notification";
const keys = require("../config/keys");

export const logOutCurrentUser = function(dispatch) {
  delete axios.defaults.headers.common["token"];
  const res = {};
  res.redirectToLogin = true;
  res.logOut = true;
  dispatch({ type: LOGOUT, payload: res });
};

export const fetchUser = objUserDetails => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionLogin/login",
    data: {
      UserName: objUserDetails.username,
      Password: objUserDetails.password,
      RememberMe: objUserDetails.rememberMe
    }
  })
    .then(res => {
      // console.log(res.data.paymentvendor);
      let auth = {};
      if (res.data.userDetails) {
        if (res.data.userDetails[0].IsActive) {
          // console.log(res.data);
          try {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userId", res.data.userDetails[0].Id);
            localStorage.setItem("userName", res.data.userDetails[0].UserName);
            localStorage.setItem(
              "clientCode",
              res.data.userDetails[0].ClientCode
            );
            localStorage.setItem("orgId", res.data.userDetails[0].orgId);
            localStorage.setItem("isFilled", res.data.userDetails[0].IsFilled);
            localStorage.setItem("IsLoggedIn", true);

            setAuthorizationToken(res.data.token);
            // console.log(res.data.token);
            auth.userId = res.data.userDetails[0].Id;
            auth.userName = res.data.userDetails[0].UserName;
            auth.userType = res.data.userDetails[0].UserTypeId;
            auth.clientCode = res.data.userDetails[0].ClientCode;
            auth.clientId = res.data.userDetails[0].ClientId;
            auth.orgId = res.data.userDetails[0].OrgId;
            auth.paymentvendor = res.data.paymentvendor;
            // auth.userId = res.data.userDetails[0].Id;
            // auth.instituteTypeId = res.data.userDetails[0].instituteTypeId;
            // auth.ayId = res.data.userDetails[0].ayId;
            // auth.ayName = res.data.userDetails[0].ayName;
            // auth.educationBodyId = res.data.userDetails[0].educationBodyId;
            // auth.startDate = res.data.userDetails[0].startDate;
            // auth.endDate = res.data.userDetails[0].endDate;
            // auth.organizationName = res.data.userDetails[0].organizationName;
            // auth.organizationLogo = res.data.userDetails[0].organizationLogo;
            // auth.parentOrganization =
            //   res.data.userDetails[0].parentOrganization;
            auth.showLoader = false;
            auth.logOut = false;
            auth.isLoggedIn = true;
            auth.redirectToLogin = false;
            auth.redirectToApplication = true;
            auth.message = "Welcome user";

            //getpaymentvendors();
            dispatch({ type: FETCH_USER, payload: auth });
            //createHistory.push('/applicationform');
          } catch (exc) {
            console.log("exception", exc);
          }
          notification("success", "Login", "Successfully Login");
        } else if (!res.data.userDetails[0].IsActive) {
          auth.showLoader = false;
          auth.message = "Access Denied";
          dispatch({ type: FETCH_USER, payload: auth });
        }
      } else {
        auth.showLoader = false;
        auth.message = "Invalid username or password";
        dispatch({ type: FETCH_USER, payload: auth });
        notification("error", "Invalid", "Check your Username & Password");
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const checkUserToken = (objTokenDetails, userType) => async dispatch => {
  setAuthorizationToken(objTokenDetails);
  await axios({
    method: "get",
    headers: { token: objTokenDetails },
    url: keys.ServicePath + "/api/AdmissionLogin/chkToken"
  })
    .then(res => {
      // console.log(res.data.data);
      //const token = jwt_decode(objTokenDetails);
      if (userType === res.data.data.usertypeid || userType === 0) {
        const auth = {};
        auth.userId = res.data.data.id;
        auth.userName = res.data.data.userName;
        auth.userType = res.data.data.usertypeid;
        auth.orgId = res.data.data.orgId;
        auth.clientCode = res.data.data.clientCode;
        auth.clientId = res.data.data.clientId;
        auth.isFilled = res.data.data.isFilled;
        auth.paymentvendor = res.data.data.paymentvendor;
        // auth.instituteTypeId = res.data.data.instituteTypeId;
        // auth.clientId = res.data.data.clientId;
        // auth.ayId = res.data.data.ayId;
        // auth.ayName = res.data.data.ayName;
        // auth.educationBodyId = res.data.data.educationBodyId;
        // auth.startDate = res.data.data.startDate;
        // auth.endDate = res.data.data.endDate;
        auth.showLoader = false;
        auth.logOut = false;
        auth.isLoggedIn = true;
        auth.logIn = true;
        auth.redirectToLogin = false;
        auth.redirectToApplication = true;
        // auth.organizationName = res.data.data.organizationName;
        // auth.organizationLogo = res.data.data.organizationLogo;
        // auth.parentOrganization = res.data.data.parentOrganization;
        dispatch({ type: CHECK_TOKEN, payload: auth });
      } else {
        logOutCurrentUser(dispatch);
      }
    })
    .catch(e => {
      logOutCurrentUser(dispatch);
      //console.log("catch error", JSON.stringify(e));
    });
};

export const logout = () => async dispatch => {
  window.sessionStorage.clear();
  window.localStorage.clear();
  logOutCurrentUser(dispatch);
  window.location.reload();
  // setTimeout(() => {
  //   window.location.reload();
  // }, 500);
};

export const forgotPassword = data => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionLogin/forgatpssword",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: FORGET_PASSWORD, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      } else {
        const msg = {
          event: "error",
          page: "forgotPassword",
          data: res.data.data,
          success: false
        };
        dispatch({ type: UPDATE_DATA, payload: msg });
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const forgotPasswordSendOTP = data => async dispatch => {
  let isOtpSent = false;
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionLogin/ForgotPasswordSendOTP",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          isOtpSent = res.data.isOtpSent;
          const msg = {
            event: "success",
            // page: "forgotPassword",
            data: res.data.data,
            // action: "add",
            success: true,
            ...res.data
          };
          dispatch({ type: UPDATE_DATA, payload: msg });
          dispatch({
            type: USER_DETAIL_OTP_FORGOTPASS,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  return isOtpSent;
};

export const checkVerifyOtpResetPassword = data => async dispatch => {
  let isOtpVerify = false;
  let isError = false;
  let errorMsg = "";
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionLogin/CheckVerifyOtpResetPassword",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          let msg;
          if (res.data.isOtpVerify) {
            isOtpVerify = true;
            msg = {
              event: "success",
              data: res.data.data,
              success: true,
              ...res.data
            };
          } else {
            isOtpVerify = false;
            isError = true;
            errorMsg = "OTP Is Invalid";
            msg = {
              event: "error",
              data: res.data.data,
              success: true,
              ...res.data
            };
          }
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  return { isOtpVerify, isError, errorMsg };
};

export const getpaymentvendors = data => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/payment/getpaymentvendors",
    data: data
  })
    .then(res => {
      if (res.data) {
        try {
          window.location = res.data;
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/login/auth.js